module.exports = __webpack_public_path__ + "static/media/roadmpap-1.fe3ae8fe.png";